import List from "@mui/material/List";
import { StoryblokComponent, storyblokEditable } from "@storyblok/react";

interface IListProps {
  blok: { items: any };
}

const ListComponent = ({ blok }: IListProps) => {
  return (
    <List
      dense={false}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        width: "100%",
        height: "280px",
        paddingRight: "10px",
        overflowY: "auto",
      }}
      {...storyblokEditable(blok)}
    >
      {blok.items.map((blok: any) => (
        <StoryblokComponent blok={blok} key={blok._uid} />
      ))}
    </List>
  );
};

export default ListComponent;
